import api from "../index";

// ** --------- Email Sequence API --------- ** //
// Create an email sequence
export const createEmailSequence = (values: any) => {
  return api.post("/email-sequence", values);
};

// Get all email sequences
export const getAllEmailSequences = () => {
  return api.get("/email-sequences");
};

// Get all email sequences paginated
export const getEmailSequencesPaginated = async (
  page: any,
  perPage: any,
  searchText?: string
) => {
  if (!searchText) {
    return await api.get(
      `/email-sequences/paginated?page=${page}&perPage=${perPage}`
    );
  } else {
    return await api.get(
      `/email-sequences/paginated?page=${page}&perPage=${perPage}&searchText=${searchText}`
    );
  }
};

// Get an email sequence by ID
export const getEmailSequenceById = (id: string) => {
  return api.get(`/email-sequence/${id}`);
};

// Update an email sequence by ID
export const updateEmailSequenceById = (id: string, values: any) => {
  return api.put(`/email-sequence/${id}`, values);
};

// Delete an email sequence by ID
export const deleteEmailSequenceById = (id: string) => {
  return api.delete(`/email-sequence/${id}`);
};

// Get email sequence analytics
export const getEmailSequenceAnalytics = (id: string) => {
  return api.get(`/email-sequence/${id}/analytics`);
};

// ** --------- Real-time Analytics API --------- ** //

// Get live sequence analytics for dashboard
export const getSequenceAnalyticsLive = () => {
  return api.get("/email-sequences/analytics/live");
};

// Get sequence queue status
export const getSequenceQueueStatus = () => {
  return api.get("/email-sequences/queue-status");
};

// Get active sequence users
export const getActiveSequenceUsers = (limit?: number, offset?: number) => {
  const params = new URLSearchParams();
  if (limit) params.append('limit', limit.toString());
  if (offset) params.append('offset', offset.toString());
  
  const queryString = params.toString();
  return api.get(`/email-sequences/active-users${queryString ? `?${queryString}` : ''}`);
};

// Get sequence processing metrics
export const getSequenceProcessingMetrics = (timeframe?: string) => {
  const params = timeframe ? `?timeframe=${timeframe}` : '';
  return api.get(`/email-sequences/processing-metrics${params}`);
};

// Get user email progress
export const getUserEmailProgress = (userId: string) => {
  return api.get(`/email-sequence/progress/${userId}`);
};

// Get user email sequence analytics
export const getUserEmailSequenceAnalytics = (userId: string) => {
  return api.get(`/email-sequence/user/${userId}/analytics`);
};

// Stop user email sequence
export const stopUserEmailSequence = (sequenceId: string, userId: string) => {
  return api.post(`/email-sequence/${sequenceId}/stop/${userId}`);
};

// Trigger email sequence
export const triggerEmailSequence = (
  sequenceId: string,
  userId: string,
  triggerType: string
) => {
  return api.post(`/email-sequence/${sequenceId}/trigger`, {
    userId,
    triggerType,
  });
};

// Get sequence recipients (similar to campaign recipients)
export const getSequenceRecipients = async (
  sequenceId: string,
  params: {
    page?: number;
    perPage?: number;
    status?: string;
    searchText?: string;
    sortBy?: string;
    sortOrder?: string;
  } = {}
) => {
  const queryParams = new URLSearchParams({
    page: String(params.page || 1),
    perPage: String(params.perPage || 10),
    sortBy: params.sortBy || 'startedAt',
    sortOrder: params.sortOrder || 'desc',
  });

  if (params.status) queryParams.append('status', params.status);
  if (params.searchText) queryParams.append('searchText', params.searchText);

  return await api.get(`/email-sequence/${sequenceId}/recipients?${queryParams.toString()}`);
};
